import { api } from './api';

const cityGetList = async () => {
    const response = await api({
        url: `Cities/getList`,
        method: 'GET',
    });
    return response.data;
};

const countyGetList = async (cityId) => {
    const response = await api({
        url: `Countys/getList`,
        method: 'GET',
        params: {
            cityId: cityId,
        },
    });
    return response.data;
};

const neighborhoodGetList = async (countyId) => {
    const response = await api({
        url: `Neighborhoods/getList`,
        method: 'GET',
        params: {
            countyId: countyId,
        },
    });
    return response.data;
};

const lookupServices = {
  cityGetList,
  countyGetList,
  neighborhoodGetList,
};

export default lookupServices;
